// ここからDawnのコードに追加
// plusボタン、minusボタンの実装
const quantityEelement  = document.querySelector('#quantity');
const plusButton  = document.querySelector('#btn-plus');
const minusButton  = document.querySelector('#btn-minus');

const quantityChange = (e) => {
  if (e.target === plusButton) {
    quantityEelement.stepUp(1);
  } else {
    quantityEelement.stepDown(1);
  }
}

plusButton.addEventListener('click', quantityChange);
minusButton.addEventListener('click', quantityChange);